export const SKELETON_SLIDER = [
  {
    type: 'group',
    slider: true,
    columns: 6,
    gap: '1rem',
    className: 'hidden flex overflow-x-hidden flex-col',
    items: [
      {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'flex-start',
        items: [
            {
                type: 'rect', width: '240px', height: '268px', className: 'mb-3'
            },
            {
                type: 'rect', width: '180px', height: '14px', className: 'mb-0.5'
            },
            {
                type: 'rect', width: '100%', height: '16px', className: 'mb-1'
            },
            {
                type: 'rect', width: '60px', height: '20px', className: 'mb-3'
            },
            {
                type: 'rect', width: '100%', height: '24px', className: ''
            }
        ]
      }
    ]
  }
];
export const SKELETON_SLIDER_MOBILE = [
  {
      type: 'group',
      slider: true,
      columns: 6,
      gap: 8,
      className: 'hidden flex overflow-x-hidden flex-col px-4',
      items: [
          {
              type: 'group',
              flexDirection: 'column',
              alignItems: 'flex-start',
              items: [
                  {
                      type: 'rect', width: '160px', height: '206px', className: ''
                  },
                  {
                      type: 'rect', width: '160px', height: '14px', className: 'mt-3'
                  },
                  {
                      type: 'rect', width: '100%', height: '18px', className: 'mt-0.5'
                  },
                  {
                      type: 'rect', width: '60px', height: '24px', className: 'mt-1'
                  },
                  {
                      type: 'rect', width: '100%', height: '34px', className: 'mt-0.5'
                  }
              ]
          }
      ]
  }
];
